




import { Vue, Component } from "@/shared/vuepack";
import DocumentSignature from "@/employee/components/DocumentSignature.vue";
import { SigisLicenseAgreementDocumentKey } from "@/employee/store/productScanner";

@Component({
  components: {
    DocumentSignature,
  },
})
export default class SigisLicenseAgreement extends Vue {
  get documentKey () {
    return SigisLicenseAgreementDocumentKey;
  }
}
